import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './breadcrumb-divider.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


initializeIconsByRole({
  'cse-breadcrumb-divider.icon': { name: 'angle-right', style: 'regular' },
})

@customElement('cse-breadcrumb-divider')
export class CSEBreadcrumbDivider extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  override render() {
    return html`
      <div class="cse-breadcrumb-divider font-body-s">
        <cse-icon class="icon" icon-role="cse-breadcrumb-divider.icon"></cse-icon>
      </div>
`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-breadcrumb-divider': CSEBreadcrumbDivider
  }
}
